export const isAbsoluteUrl = (url) => {
  const regex = /(http(s?)):\/\//i;
  return regex.test(url);
};
